export default __webpack_public_path__ + "static/media/curious_logo2.9650ccee.jpg";